
import { metaData } from '~/configuration/metaData';
import { CMSService } from '~/services/storyBlok/cmsService';

export default {
  name: 'HowItWorksPage',
  head: {
    ...metaData.home,
  },
  async asyncData({ $storyapi, error }) {
    const storyBlok = new CMSService({ cmsService: $storyapi });
    try {
      const pageData = await storyBlok.get('v4/how-it-works');

      return { storyResp: pageData?.data?.story?.content };
    } catch (err) {
      error({ message: err?.message });
    }

    return [];
  },
};
